import type {
  MissionKindEnum,
  MissionWorkflowCategoryEnum,
} from '@e-socna/data-layer';

import { missionKindProfileOf } from '../../../app/utils/mission-kind-profile.util';

export const filterMissionWorkflowsOfKind = <
  W extends Readonly<{ category: MissionWorkflowCategoryEnum }>,
>(
  workflows: readonly W[],
  kind: MissionKindEnum,
): readonly W[] =>
  workflows.filter(
    (workflow) =>
      workflow.category === missionKindProfileOf(kind).workflowCategory,
  );
